import { Component } from '@angular/core';

@Component({
    selector: 'app-layout',
    templateUrl: './public-layout.component.html',
    styleUrls: ['./public-layout.component.scss'],
})
export class PublicLayoutComponent {

    constructor() { }
}
